

export default {
    name: 'LeeColorDisk',
    inheritAttrs: false,
    data() {
        return {
            drag: false,//用来判断三角标尺是否按下
            pressBar: false,//用来判断HSV色轨bar是否按下
            hit: false,//用来判断是否要出现quan颜色吸管
            hitP: {//quan颜色吸管位置
                x: 0, y: 0
            },
            press: false,
            which: 'hsv',//这个很重要，用来标记现在是哪个启动触发（RGB,HSV,COLOR）
            H: 0,
            S: 100,
            V: 100,
            HSV: {
                H: 0,
                S: 100,
                V: 100
            },
            R: '',
            G: '',
            B: '',
            RGB: {
                R: '',
                G: '',
                B: ''
            },
            color: '',//16进制颜色
            hcolor: ''//以h为生成的16进制颜色,这样是为了产生界面有渐变得色盘
        }
    },
    watch: {
        H: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.HSV, 'H', value)
                //hcolor生成
                let hsv = value + ',' + 100 + ',' + 100
                let rgb = this.hsvToRgb(hsv)
                //设置color
                let color = this.rgbTo16(rgb.R + ',' + rgb.G + ',' + rgb.B)
                this.$set(this, 'hcolor', color)

            }
        },
        S: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.HSV, 'S', value)
            }
        },
        V: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.HSV, 'V', value)
            }
        },
        R: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.RGB, 'R', value)
            }
        },
        G: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.RGB, 'G', value)
            }
        },
        B: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$set(this.RGB, 'B', value)
            }
        },
        HSV: {
            immediate: true,
            deep: true,
            handler(value) {
                if (this.which === 'hsv') {
                    let hsv = value.H + ',' + value.S + ',' + value.V
                    let rgb = this.hsvToRgb(hsv)
                    //设置R,G,B
                    this.$set(this, 'R', rgb.R)
                    this.$set(this, 'G', rgb.G)
                    this.$set(this, 'B', rgb.B)
                    //设置color
                    let color = this.rgbTo16(rgb.R + ',' + rgb.G + ',' + rgb.B)
                    this.$set(this, 'color', color)
                }
            }
        },
        RGB: {
            immediate: true,
            deep: true,
            handler(value) {
                if (this.which === 'rgb') {
                    //设置color
                    let color = this.rgbTo16(value.R + ',' + value.G + ',' + value.B)
                    this.$set(this, 'color', color)
                    //设置H,S,V
                    let hsv = this.rgbToHsv(value.R + ',' + value.G + ',' + value.B)
                    this.$set(this, 'H', hsv.H)
                    this.$set(this, 'S', hsv.S)
                    this.$set(this, 'V', hsv.V)
                }
            }
        },
        color: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$emit('complete', value)
                if (this.which === 'color') {
                    // //设置R,G,B
                    let rgb = this.toRgb(value)
                    this.$set(this, 'R', rgb.R)
                    this.$set(this, 'G', rgb.G)
                    this.$set(this, 'B', rgb.B)
                    // //设置H,S,V
                    let hsv = this.rgbToHsv(rgb.R + ',' + rgb.G + ',' + rgb.B)
                    this.$set(this, 'H', hsv.H)
                    this.$set(this, 'S', hsv.S)
                    this.$set(this, 'V', hsv.V)
                }
            }
        }
    },
    computed: {
        pdcolor() {
            let bcolor
            if (this.S < 20 && this.V > 80) {
                bcolor = "#000"
            } else {
                bcolor = "#fff"
            }
            return bcolor
        }
    },
    methods: {
        barColorPc(pd) {//pc端
            if (pd) {
                let {height} = event.currentTarget.getBoundingClientRect()
                let y = event.offsetY + 1 > 0 ? event.offsetY + 1 : 0
                this.H = Math.round((height - y) * (360 / height))
                this.which = 'hsv'
            }
        },
        barColorMobile(pd) {//移动端
            if (pd) {
                this.which = 'hsv'
                let {height} = event.currentTarget.getBoundingClientRect()
                //let y = event.offsetY + 1 > 0 ? event.offsetY + 1 : 0
                let y = event.targetTouches[0].clientY - (event.currentTarget.offsetTop - document.documentElement.scrollTop)
                if (y > height) {
                    y = height
                }
                if (y < 0) {
                    y = 0
                }

                this.H = Math.round((height - y) * (360 / height))
            }
        },
        squareColorPc(pd) {//pc端
            if (pd) {
                this.which = 'hsv'
                let x = event.offsetX + 1
                let y = event.offsetY + 1
                let {width, height} = event.currentTarget.getBoundingClientRect()
                this.S = Math.round(100 * x / width) > 100 ? 100 : Math.round(100 * x / width)
                this.V = Math.round(100 - 100 * y / height) > 100 ? 100 : Math.round(100 - 100 * y / height)

            }
        },
        squareColorMobile(pd) {//移动端
            if (pd) {
                this.which = 'hsv'
                let {width, height} = event.currentTarget.getBoundingClientRect()
                let rx = event.targetTouches[0].clientX - event.currentTarget.offsetLeft
                let ry = event.targetTouches[0].clientY - (event.currentTarget.offsetTop - document.documentElement.scrollTop)
                if (Math.round(100 * rx / width) > 100) {
                    this.S = 100
                } else if (Math.round(100 * rx / width) < 0) {
                    this.S = 0
                } else {
                    this.S = Math.round(100 * rx / width)
                }
                if (Math.round(100 - 100 * ry / height) > 100) {
                    this.V = 100
                } else if (Math.round(100 - 100 * ry / height) < 0) {
                    this.V = 0
                } else {
                    this.V = Math.round(100 - 100 * ry / height)
                }
            }
        },
        circleColorPc(pd) {//pc端
            if (pd) {
                this.hit = true
                let {width, height} = event.currentTarget.getBoundingClientRect()
                let x = event.offsetX + 1 - width / 2
                let y = width / 2 - (event.offsetY + 1)
                let hsv = this.CircleHsv(x, y, width / 2)//得到HSV值
                let rgb = this.hsvToRgb(hsv)
                let rgbString = rgb.R + ',' + rgb.G + ',' + rgb.B
                this.$emit('complete', this.rgbTo16(rgbString))
                let xx = event.offsetX + 1 > width ? width : event.offsetX + 1
                let yy = event.offsetY + 1 > height ? height : event.offsetY + 1
                this.$set(this.hitP, 'x', xx)
                this.$set(this.hitP, 'y', yy)

            }
        },
        circleColorMobile(pd) {//移动端
            if (pd) {
                this.hit = true
                let {width, height} = event.currentTarget.getBoundingClientRect()
                let rx = event.targetTouches[0].clientX - event.currentTarget.offsetLeft
                let ry = event.targetTouches[0].clientY - (event.currentTarget.offsetTop - document.documentElement.scrollTop)
                if (rx > width) {
                    rx = width
                } else if (rx < 0) {
                    rx = 0
                }
                if (ry > height) {
                    ry = height
                } else if (ry < 0) {
                    ry = 0
                }
                let x = rx - width / 2
                let y = width / 2 - ry
                let hsv = this.CircleHsv(x, y, width / 2)//得到HSV值
                console.log(hsv)
                let rgb = this.hsvToRgb(hsv)
                let rgbString = rgb.R + ',' + rgb.G + ',' + rgb.B
                this.$emit('complete', this.rgbTo16(rgbString))
                this.$set(this.hitP, 'x', rx)
                this.$set(this.hitP, 'y', ry)
            }
        },
        CircleHsv(x, y, w) {//circle形狀時
            let datax = Math.abs(x)
            let datay = Math.abs(y)
            let Tan = datay / datax //正切
            // 斜边
            let hypotenuse = Math.sqrt(x * x + y * y)
            if (hypotenuse > this.width / 2) {
                hypotenuse = this.width / 2
            }
            let hypotenuseReturn = Math.round((100 / w) * hypotenuse)
            let dataAtan = Math.round(Number(Math.atan(Tan)) / (Math.PI / 180))//获得角度
            let angle = 0
            if (x > 0 && y > 0) {
                angle = 90 - dataAtan
            } else if (x > 0 && y < 0) {
                angle = 90 + dataAtan
            } else if (x < 0 && y < 0) {
                angle = 270 - dataAtan
            } else if (x < 0 && y > 0) {
                angle = 270 + dataAtan
            }
            return angle + "," + hypotenuseReturn + "," + 100//h,s,v

        },
        toRgb(color) {
            let colors = color.indexOf('#') > -1 ? color.split('#')[1] : color
            let lastColor = ''
            let zero = ''
            if (colors.length === 3) {
                lastColor = colors.slice(0, 1) + colors.slice(0, 1) + colors.slice(1, 2) + colors.slice(1, 2) + colors.slice(2, 3) + colors.slice(2, 3)

            } else {
                let buzeroNum = 6 - colors.length
                for (let i = 0; i < buzeroNum; i++) {
                    zero += '0'
                }
                lastColor = zero + colors
            }
            let r = lastColor.slice(0, 2)
            let r1 = r.slice(0, 1)
            let r2 = r.slice(1, 2)
            let g = lastColor.slice(2, 4)
            let g1 = g.slice(0, 1)
            let g2 = g.slice(1, 2)
            let b = lastColor.slice(4, 6)
            let b1 = b.slice(0, 1)
            let b2 = b.slice(1, 2)
            let R = Number(this.toNum(r1) * 16) + Number(this.toNum(r2))
            let G = Number(this.toNum(g1) * 16) + Number(this.toNum(g2))
            let B = Number(this.toNum(b1) * 16) + Number(this.toNum(b2))
            return {
                R: R,
                G: G,
                B: B
            };
        },
        toNum(str) {
            switch (str) {
                case 'a':
                case 'A':
                    str = 10
                    break;
                case 'b':
                case 'B':
                    str = 11
                    break;
                case 'c':
                case 'C':
                    str = 12
                    break;
                case 'd':
                case 'D':
                    str = 13
                    break;
                case 'e':
                case 'E':
                    str = 14
                    break;
                case 'f':
                case 'F':
                    str = 15
                    break;
            }
            return str
        },
        rgbTo16(color) {
            let lastColor = ''
            let colors = color.split(',')
            if (colors.length != 3) {
                lastColor = '你输入的RGB值错误'
                return lastColor
            }
            let r = colors[0]
            let g = colors[1]
            let b = colors[2]
            let fr = String(this.toLetter(Math.floor(r / 16)))
            let lr = String(this.toLetter(r % 16))
            let fg = String(this.toLetter(Math.floor(g / 16)))
            let lg = String(this.toLetter(g % 16))
            let fb = String(this.toLetter(Math.floor(b / 16)))
            let lb = String(this.toLetter(b % 16))
            lastColor = fr + lr + fg + lg + fb + lb
            return lastColor
        },
        toLetter(str) {
            switch (str) {
                case 10:
                    str = 'a'
                    break;
                case 11:
                    str = 'b'
                    break;
                case 12:
                    str = 'c'
                    break;
                case 13:
                    str = 'd'
                    break;
                case 14:
                    str = 'e'
                    break;
                case 15:
                    str = 'f'
                    break;
            }
            return str
        },
        hsvToRgb(hsv) {
            let r, g, b, i, f, p, q, t;
            let h = hsv.split(',')[0]
            let s = hsv.split(',')[1]
            let v = hsv.split(',')[2]
            //自己写的补充
            h = h / 360
            s = s / 100
            v = v / 100

            //
            i = Math.floor(h * 6);
            f = h * 6 - i;
            p = v * (1 - s);
            q = v * (1 - f * s);
            t = v * (1 - (1 - f) * s);
            switch (i % 6) {
                case 0:
                    r = v, g = t, b = p;
                    break;
                case 1:
                    r = q, g = v, b = p;
                    break;
                case 2:
                    r = p, g = v, b = t;
                    break;
                case 3:
                    r = p, g = q, b = v;
                    break;
                case 4:
                    r = t, g = p, b = v;
                    break;
                case 5:
                    r = v, g = p, b = q;
                    break;
            }
            return {
                R: Math.round(r * 255),
                G: Math.round(g * 255),
                B: Math.round(b * 255)
            };


        },
        rgbToHsv(rgb) {
            let r = Number(rgb.split(',')[0])
            let g = Number(rgb.split(',')[1])
            let b = Number(rgb.split(',')[2])
            let max = Math.max(r, g, b), min = Math.min(r, g, b),
                d = max - min,
                h,
                s = (max === 0 ? 0 : d / max),
                v = max / 255;

            switch (max) {
                case min:
                    h = 0;
                    break;
                case r:
                    h = (g - b) + d * (g < b ? 6 : 0);
                    h /= 6 * d;
                    break;
                case g:
                    h = (b - r) + d * 2;
                    h /= 6 * d;
                    break;
                case b:
                    h = (r - g) + d * 4;
                    h /= 6 * d;
                    break;
            }

            return {
                H: Math.round(h * 360),
                S: Math.round(s * 100),
                V: Math.round(v * 100)
            };

        },
        mrgb(w) {//RGB输入处理
            let yz = new RegExp("^[0-9]{1,3}$");
            let value = this.$refs[w].value
            if (!yz.test(value)) {
                value = value.replace(/[^0-9]/g, '')
            }
            if (Number(value) > 255) {
                value = 255
            }
            this.$refs[w].value = Number(value)
            this[w] = Number(value)
            //
            this.which = 'rgb'
        },
        msv(w) {//SV输入处理
            let yz = new RegExp("^[0-9]{1,3}$");
            let value = this.$refs[w].value
            if (!yz.test(value)) {
                value = value.replace(/[^0-9]/g, '')
            }
            if (Number(value) > 100) {
                value = 100
            }
            this.$refs[w].value = Number(value)
            this[w] = Number(value)
            //
            this.which = 'hsv'
        },
        mh(w) {//H输入处理
            let yz = new RegExp("^[0-9]{1,3}$");
            let value = this.$refs[w].value
            if (!yz.test(value)) {
                value = value.replace(/[^0-9]/g, '')
            }
            if (Number(value) > 360) {
                value = 360
            }
            this.$refs[w].value = Number(value)
            this[w] = Number(value)
            //
            this.which = 'hsv'
        },
        mcolor(w) {//H输入处理
            let yz = new RegExp("^[0-9a-fA-F]{1,6}$");
            let value = this.$refs[w].value
            if (!yz.test(value)) {
                value = value.replace(/[^0-9a-fA-F]/g, '')
            }
            let lastColor = ''
            let zero = ''
            if (value.length === 3) {
                value = value.slice(0, 1) + value.slice(0, 1) + value.slice(1, 2) + value.slice(1, 2) + value.slice(2, 3) + value.slice(2, 3)

            } else {
                let buzeroNum = 6 - value.length
                for (let i = 0; i < buzeroNum; i++) {
                    zero += '0'
                }
                value = zero + value
            }
            if (value.length > 6) {
                value = value.slice(0, 6)
            }
            this.$refs[w].value = value
            this[w] = value
            //
            this.which = 'color'
        }

    },
    props: {
        width: {
            type: Number,
            default: 300
        },
        height: {
            type: Number,
            default: 300
        },
        shape: {
            type: String,
            default: 'circle'
        }
    }
};
